import { Select } from "@cofano/cck";
import { intl } from "LocaleWrapper";
import client from "../../../../apollo";
import {
	NextShipNominationStatusesDocument,
	NextShipNominationStatusesQuery,
} from "__generated__/view/charters/graphql/charter.queries.generated";
import { SelectProps } from "@cofano/cck/Select/Select";
import { ChildPropsFromArray } from "types/commons";
import { ShipNominationStatus } from "__generated__/enums";

export type ShipNominationStatusSelectOption = ChildPropsFromArray<NextShipNominationStatusesQuery, "nextShipNominationStatuses">;

const ShipNominationStatusSelect = ({
	currentStatus,
	...rest
}: Omit<SelectProps<ShipNominationStatusSelectOption, false>, "fetchOptions" | "paginated" | "multiple"> & {
	currentStatus?: ShipNominationStatus | null;
}) => {

	const onFetchOptions = async () => {
		try  {
			const result = await client.query({
				query: NextShipNominationStatusesDocument,
				variables: {
					currentStatus: currentStatus,
				},
			});

			return result.data.nextShipNominationStatuses;
		} catch (response) {
			return [];
		}
	};

	return (
		<Select
			fetchOptions={onFetchOptions}
			getOptionLabel={(option) => intl.formatMessage({ id: `STATUS_${option.name}` })}
			getOptionColor={option => option.color}
			disableSearch
			{...rest}
		/>
	);
};

export default ShipNominationStatusSelect;
